import { createError } from "core/exceptions";
import { createSagasForBasicCall } from "core/sagas";
import { call, put, takeLatest } from "redux-saga/effects";
import TemplatesService from "services/templatesService";
import { actions } from "./actions";

export function* saveTemplate({ payload: template }) {
    try {
        let response = null;
        if (template.id) {
            response = yield call(TemplatesService.edit, template);
            response = { ...response, editing: true };
        } else {
            response = yield call(TemplatesService.create, template);
        }

        yield put(
            actions.SAVE_TEMPLATE.success({
                data: response,
            })
        );
    } catch (e) {
        yield put(actions.SAVE_TEMPLATE.failed(null, createError(e)));
    }
}

export function* deleteTemplate({ payload }) {
    try {
        yield call(TemplatesService.delete, payload);
        yield put(
            actions.DELETE_TEMPLATE.success({
                data: payload,
            })
        );
    } catch (e) {
        yield put(actions.DELETE_TEMPLATE.failed(null, createError(e)));
    }
}

export default [
    ...createSagasForBasicCall(actions),
    takeLatest(actions.SAVE_TEMPLATE.sendType, saveTemplate),
    takeLatest(actions.DELETE_TEMPLATE.sendType, deleteTemplate),
];
